import { ROUTE } from '@/routes/constants';
import { Clock } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import Cookies from 'js-cookie';

// 受限页：继承登录页语言（cookie），并提供显式语言切换入口（ZH-14）。
// 显示 HKT 时区与下次开放时间（EN-18）。
export default function AccessRestrictedPage() {
  const { t, i18n } = useTranslation();
  const startTime = import.meta.env.VITE_ALLOWED_START_TIME || '6:00';
  const endTime = import.meta.env.VITE_ALLOWED_END_TIME || '23:00';

  const setLang = (lng: 'en' | 'zh-HK') => { i18n.changeLanguage(lng); Cookies.set('i18next', lng); };
  const isEn = (i18n.language || '').startsWith('en');

  return (
    <div className="flex h-screen w-screen items-center justify-center bg-background-white">
      <div className="mx-4 max-w-md rounded-3xl border border-gray-100 bg-white p-10 text-center shadow-xl dark:border-gray-800 dark:bg-gray-900">
        <div className="mb-6 flex justify-center">
          <div className="rounded-full bg-amber-100 p-4">
            <Clock className="h-10 w-10 text-amber-600" />
          </div>
        </div>
        <h1 className="mb-4 text-2xl font-bold text-gray-900 dark:text-gray-100">
          {t('access-restricted.title')}
        </h1>
        <p className="mb-2 text-gray-600 dark:text-gray-400">
          {t('access-restricted.message', { startTime, endTime })}
        </p>
        <p className="mb-6 text-sm text-gray-500 dark:text-gray-500">
          {t('access-restricted.reopens', { defaultValue: '將於 {{startTime}}（HKT）重新開放', startTime })}
        </p>
        <Link
          to={ROUTE.LOGIN}
          className="inline-block rounded-lg bg-gray-900 px-6 py-2 text-white hover:bg-gray-800"
        >
          {t('access-restricted.back-to-login')}
        </Link>
        {/* 语言切换入口：保证繁中流程下可切回英文，反之亦然（ZH-14） */}
        <div className="mt-6 flex items-center justify-center gap-2">
          <button
            type="button"
            onClick={() => setLang('en')}
            className={`rounded-md px-3 py-1 text-sm ${isEn ? 'bg-gray-900 text-white' : 'text-gray-600 hover:bg-gray-100'}`}
          >
            English
          </button>
          <button
            type="button"
            onClick={() => setLang('zh-HK')}
            className={`rounded-md px-3 py-1 text-sm ${!isEn ? 'bg-gray-900 text-white' : 'text-gray-600 hover:bg-gray-100'}`}
          >
            繁體
          </button>
        </div>
      </div>
    </div>
  );
}
